import { rfpRequest } from './reducers';
export default rfpRequest;
